/* NUOMA Contact — photo links via Cloudinary, Shopify native mail remains source of truth. */
(function () {
  function init(root) {
    if (!root || root.dataset.nuomaContactReady === 'yes') return;
    root.dataset.nuomaContactReady = 'yes';
    var form = root.querySelector('form');
    var input = root.querySelector('[data-nuoma-photo-input]');
    if (!form) return;
    var productParam = new URLSearchParams(window.location.search).get('produit');
    var messageField = form.querySelector('textarea[name="contact[body]"]');
    if (productParam && messageField && !messageField.value.trim()) {
      messageField.value = 'Bonjour, j’ai une question concernant « ' + productParam.slice(0, 120) + ' ».\n\n';
    }
    if (!input) return;
    var linksInput = root.querySelector('[data-nuoma-photo-links]');
    var fileList = root.querySelector('[data-nuoma-file-list]');
    var status = root.querySelector('[data-nuoma-file-status]');
    var submit = root.querySelector('[data-nuoma-submit]');
    var maxCount = Number(root.dataset.photoMax) || 3;
    var maxMB = Number(root.dataset.photoMb) || 8;
    var name = root.dataset.cloudName || '';
    var preset = root.dataset.cloudPreset || '';
    var allowed = /\.(jpe?g|png|webp|heic|heif)$/i;
    function notice(message, error) {
      status.textContent = message;
      status.dataset.state = error ? 'error' : 'info';
    }
    function validate(files) {
      if (files.length > maxCount) return 'Vous pouvez joindre jusqu’à ' + maxCount + ' photos.';
      for (var i=0; i<files.length; i++) {
        if (!allowed.test(files[i].name)) return 'Format non accepté : JPG, PNG, WebP ou HEIC uniquement.';
        if (files[i].size > maxMB * 1024 * 1024) return 'Chaque photo doit peser moins de ' + maxMB + ' Mo.';
      }
      return '';
    }
    input.addEventListener('change', function () {
      form.dataset.nuomaUploadDone = '';
      linksInput.value = '';
      var files = Array.from(input.files || []);
      fileList.textContent = files.length ? files.map(function (file) {return file.name;}).join(' · ') : '';
      notice(files.length ? validate(files) || (files.length + ' photo(s) sélectionnée(s).') : '', Boolean(validate(files)));
    });
    form.addEventListener('submit', async function (event) {
      var files = Array.from(input.files || []);
      if (!files.length || form.dataset.nuomaUploadDone === 'yes') return;
      event.preventDefault();
      var error = validate(files);
      if (error) {notice(error, true); input.focus(); return;}
      if (!/^[a-zA-Z0-9_-]+$/.test(name) || !/^[a-zA-Z0-9_-]+$/.test(preset)) {
        notice('L’envoi des photos n’est pas configuré. Merci de réessayer plus tard.', true);
        return;
      }
      var apiUrl = 'https://api.cloudinary.com/v1_1/' + encodeURIComponent(name) + '/image/upload';
      if (submit) submit.disabled = true;
      try {
        var photoUrls = [];
        for (var i=0; i<files.length; i++) {
          notice('Envoi de la photo ' + (i + 1) + ' sur ' + files.length + '…', false);
          var body = new FormData();
          body.append('file', files[i]);
          body.append('upload_preset', preset);
          var response = await fetch(apiUrl, {method:'POST',body:body});
          var result = await response.json();
          if (!response.ok || !result.secure_url || !/^https:\/\//.test(result.secure_url)) throw new Error('Upload failed');
          photoUrls.push(result.secure_url);
        }
        linksInput.value = photoUrls.map(function (url,i) {return 'Photo ' + (i+1) + ' : ' + url;}).join('\n');
        form.dataset.nuomaUploadDone = 'yes';
        notice('Photos envoyées. Envoi du message…', false);
        if (submit) submit.disabled = false;
        form.requestSubmit(submit);
      } catch (e) {
        notice('Impossible d’envoyer les photos. Votre message n’a pas été envoyé. Veuillez réessayer.', true);
        if (submit) submit.disabled = false;
      }
    });
  }
  function boot() {document.querySelectorAll('[data-nuoma-contact]').forEach(init);}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
